export const APP_VERSION = '0.7.1';

// Music
export const allNotes = [
    "c",
    "c#",
    "d",
    "d#",
    "e",
    "f",
    "f#",
    "g",
    "g#",
    "a",
    "a#",
    "b",
];

export const allNotesEnh = [
    "c",
    "db",
    "d",
    "eb",
    "fb",
    "f",
    "gb",
    "g",
    "ab",
    "a",
    "bb",
    "cb",
];

export const COLOURS_MERGE = ['#F4D03F', '#b3e5fc', '#bdbdbd'];

export const COLOURS = {
    "1P": '#ffee58',
    "2m": '#b3e5fc',
    "2M": '#87CEFA',
    "2A": '#87CEFA',
    "3m": '#ffcc80',
    "3M": '#ffa726',
    "4P": '#a5d6a7',
    "4A": '#66bb6a',
    "5d": '#e57373',
    "5P": '#FF4136',
    "5A": '#f44336',
    "6m": '#f8bbd0',
    "6M": '#f48fb1',
    "7d": '#e0e0e0',
    "7m": '#bdbdbd',
    "7M": '#9e9e9e'
};

export const allIntervals = ["1P", "2m", "2M", "3m", "3M", "4P", "5d", "5P", "6m", "6M", "7m", "7M"];

export const allOptionsNotes = [
    { label: 'Choose the Root/key', isHeader: true },
    { label: 'C', value: 'C' },
    { label: 'C#', value: 'C#' },
    { label: 'Db', value: 'Db' },
    { label: 'D', value: 'D' },
    { label: 'D#', value: 'D#' },
    { label: 'Eb', value: 'Eb' },
    { label: 'E', value: 'E' },
    { label: 'F', value: 'F' },
    { label: 'F#', value: 'F#' },
    { label: 'Gb', value: 'Gb' },
    { label: 'G', value: 'G' },
    { label: 'G#', value: 'G#' },
    { label: 'Ab', value: 'Ab' },
    { label: 'A', value: 'A' },
    { label: 'A#', value: 'A#' },
    { label: 'Bb', value: 'Bb' },
    { label: 'B', value: 'B' }
];

export const allOptionsTunings = [
    { label: 'Choose the tuning', isHeader: true },
    { label: 'E 4Ths', value: 'E_4Ths' },
    { label: 'E standard', value: 'E_std' },
    { label: 'Drop D', value: 'Drop_D' },
    { label: 'G open', value: 'G_open' }
];

// Fretboard
export const Tunings = {
    bass4: {
        standard: ["e1", "a1", "d2", "g2", "b2", "e3"],
    },
    guitar6: {
        standard: ["e2", "a2", "d3", "g3", "b3", "e4"],
        E_4ths: ["e2", "a2", "d3", "g3", "c4", "f4"],
        Drop_D: ["d2", "a2", "d3", "g3", "b3", "e4"],
        G_open: ["d2", "g2", "d3", "g3", "b3", "d4"],
        DADGAD: ["d2", "a2", "d3", "g3", "a3", "d4"],
    },
    guitar7: {
        standard: ["b2", "e2", "a2", "d3", "g3", "b3", "e4"],
        E_4ths: ["b2", "e2", "a2", "d3", "g3", "c3", "f4"],
    },
};

// filtered from Scale.names()...
export const allScales = [
    { label: 'Choose the scale', isHeader: true },
    { label: "Major", isHeader: true },
    { label: "major", value: "major" },
    { label: "dorian", value: "dorian" },
    { label: "phrygian", value: "phrygian" },
    { label: "lydian", value: "lydian" },
    { label: "mixolydian", value: "mixolydian" },
    { label: "aeolian", value: "aeolian" },
    { label: "locrian", value: "locrian" },
    { label: "Harmonic Minor", isHeader: true },
    { label: "harmonic minor", value: "harmonic minor" },
    { label: "locrian 6", value: "locrian 6" },
    { label: "augmented", value: "augmented" },
    { label: "dorian #4", value: "dorian #4" },
    { label: "phrygian dominant", value: "phrygian dominant" },
    { label: "lydian #9", value: "lydian #9" },
    { label: "diminished", value: "diminished" },
    { label: "Melodic Minor", isHeader: true },
    { label: "melodic minor", value: "melodic minor" },
    { label: "dorian b2", value: "dorian b2" },
    { label: "lydian augmented", value: "lydian augmented" },
    { label: "lydian dominant", value: "lydian dominant" },
    { label: "mixolydian b6", value: "mixolydian b6" },
    { label: "locrian #2", value: "locrian #2" },
    { label: "altered", value: "altered" },
    { label: "Pentatonics", isHeader: true },
    { label: "major pentatonic", value: "major pentatonic" },
    { label: "ionian pentatonic", value: "ionian pentatonic" },
    { label: "minor six pentatonic", value: "minor six pentatonic" },
    { label: "lydian pentatonic", value: "lydian pentatonic" },
    { label: "mixolydian pentatonic", value: "mixolydian pentatonic" },
    { label: "minor pentatonic", value: "minor pentatonic" },
    { label: "locrian pentatonic", value: "locrian pentatonic" },
    { label: "neopolitan major pentatonic", value: "neopolitan major pentatonic" },
    { label: "flat three pentatonic", value: "flat three pentatonic" },
    { label: "flat six pentatonic", value: "flat six pentatonic" },
    { label: "whole tone pentatonic", value: "whole tone pentatonic" },
    { label: "lydian #5P pentatonic", value: "lydian #5P pentatonic" },
    { label: "lydian dominant pentatonic", value: "lydian dominant pentatonic" },
    { label: "minor #7M pentatonic", value: "minor #7M pentatonic" },
    { label: "super locrian pentatonic", value: "super locrian pentatonic" },
    { label: "Blues", isHeader: true },
    { label: "major blues", value: "major blues" },
    { label: "minor blues", value: "minor blues" },
    { label: "composite blues", value: "composite blues" },
    { label: "Bebop", isHeader: true },
    { label: "bebop", value: "bebop" },
    { label: "bebop minor", value: "bebop minor" },
    { label: "bebop major", value: "bebop major" },
    { label: "bebop locrian", value: "bebop locrian" },
    { label: "minor bebop", value: "minor bebop" },
    { label: "Others", isHeader: true },
    { label: "minor hexatonic", value: "minor hexatonic" },
    { label: "mystery #1", value: "mystery #1" },
    { label: "egyptian", value: "egyptian" },
    { label: "six tone symmetric", value: "six tone symmetric" },
    { label: "whole tone", value: "whole tone" },
    { label: "leading whole tone", value: "leading whole tone" },
    { label: "locrian major", value: "locrian major" },
    { label: "double harmonic lydian", value: "double harmonic lydian" },
    { label: "ultralocrian", value: "ultralocrian" },
    { label: "augmented heptatonic", value: "augmented heptatonic" },
    { label: "lydian diminished", value: "lydian diminished" },
    { label: "lydian minor", value: "lydian minor" },
    { label: "neopolitan major", value: "neopolitan major" },
    { label: "harmonic major", value: "harmonic major" },
    { label: "double harmonic major", value: "double harmonic major" },
    { label: "oriental", value: "oriental" },
    { label: "flamenco", value: "flamenco" },
    { label: "persian", value: "persian" },
    { label: "enigmatic", value: "enigmatic" },
    { label: "major augmented", value: "major augmented" },
    { label: "spanish heptatonic", value: "spanish heptatonic" },
    { label: "minor six diminished", value: "minor six diminished" },
    { label: "half-whole diminished", value: "half-whole diminished" },
    { label: "chromatic", value: "chromatic" }
];

export const allChords = [
    { label: 'Major', isHeader: true },
    { label: "4", "value": "4" },
    { label: "5", "value": "5" },
    { label: "M", "value": "M" },
    { label: "M#5add9", "value": "M#5add9" },
    { label: "M13#11", "value": "M13#11" },
    { label: "M6#11", "value": "M6#11" },
    { label: "M7#5sus4", "value": "M7#5sus4" },
    { label: "M7add13", "value": "M7add13" },
    { label: "M7b5", "value": "M7b5" },
    { label: "M7b6", "value": "M7b6" },
    { label: "M7b9", "value": "M7b9" },
    { label: "M7sus4", "value": "M7sus4" },
    { label: "M9#5sus4", "value": "M9#5sus4" },
    { label: "M9b5", "value": "M9b5" },
    { label: "M9sus4", "value": "M9sus4" },
    { label: "Madd9", "value": "Madd9" },
    { label: "Maddb9", "value": "Maddb9" },
    { label: "Mb5", "value": "Mb5" },
    { label: "Mb6", "value": "Mb6" },
    { label: 'Aug', isHeader: true },
    { label: "aug", "value": "aug" },
    { label: "b9sus", "value": "b9sus" },
    { label: 'Dim', isHeader: true },
    { label: "dim", "value": "dim" },
    { label: "dim7", "value": "dim7" },
    { label: 'Minor', isHeader: true },
    { label: "m", "value": "m" },
    { label: "m#5", "value": "m#5" },
    { label: "m/ma7", "value": "m/ma7" },
    { label: "m11", "value": "m11" },
    { label: "m11A", "value": "m11A" },
    { label: "m13", "value": "m13" },
    { label: "m6", "value": "m6" },
    { label: "m69", "value": "m69" },
    { label: "m7", "value": "m7" },
    { label: "m7#5", "value": "m7#5" },
    { label: "m7add11", "value": "m7add11" },
    { label: "m7b5", "value": "m7b5" },
    { label: "m9", "value": "m9" },
    { label: "m9#5", "value": "m9#5" },
    { label: "m9b5", "value": "m9b5" },
    { label: "mMaj7b6", "value": "mMaj7b6" },
    { label: "mMaj9", "value": "mMaj9" },
    { label: "mMaj9b6", "value": "mMaj9b6" },
    { label: 'Add', isHeader: true },
    { label: "madd4", "value": "madd4" },
    { label: "madd9", "value": "madd9" },
    { label: 'Maj', isHeader: true },
    { label: "maj#4", "value": "maj#4" },
    { label: "maj13", "value": "maj13" },
    { label: "maj7", "value": "maj7" },
    { label: "maj7#5", "value": "maj7#5" },
    { label: "maj7#9#11", "value": "maj7#9#11" },
    { label: "maj9", "value": "maj9" },
    { label: "maj9#11", "value": "maj9#11" },
    { label: "maj9#5", "value": "maj9#5" },
    { label: "mb6M7", "value": "mb6M7" },
    { label: "mb6b9", "value": "mb6b9" },

    { label: "o7M7", "value": "o7M7" },
    { label: "oM7", "value": "oM7" },
    { label: 'Sus', isHeader: true },
    { label: "sus2", "value": "sus2" },
    { label: "sus24", "value": "sus24" },
    { label: "sus4", "value": "sus4" },
    { label: "+add#9", "value": "+add#9" },
    { label: "alt7", "value": "alt7" },
    { label: '6/9', isHeader: true },
    { label: "6", "value": "6" },
    { label: "6/9", "value": "6/9" },
    { label: "69#11", "value": "69#11" },
    { label: '7', isHeader: true },
    { label: "7", "value": "7" },
    { label: "7#11", "value": "7#11" },
    { label: "7#11b13", "value": "7#11b13" },
    { label: "7#5", "value": "7#5" },
    { label: "7#5#9", "value": "7#5#9" },
    { label: "7#5b9", "value": "7#5b9" },
    { label: "7#5b9#11", "value": "7#5b9#11" },
    { label: "7#5sus4", "value": "7#5sus4" },
    { label: "7#9", "value": "7#9" },
    { label: "7#9#11", "value": "7#9#11" },
    { label: "7#9#11b13", "value": "7#9#11b13" },
    { label: "7#9b13", "value": "7#9b13" },
    { label: "7add6", "value": "7add6" },
    { label: "7b13", "value": "7b13" },
    { label: "7b5", "value": "7b5" },
    { label: "7b6", "value": "7b6" },
    { label: "7b9", "value": "7b9" },
    { label: "7b9#11", "value": "7b9#11" },
    { label: "7b9#9", "value": "7b9#9" },
    { label: "7b9b13", "value": "7b9b13" },
    { label: "7b9b13#11", "value": "7b9b13#11" },
    { label: "7no5", "value": "7no5" },
    { label: "7sus4", "value": "7sus4" },
    { label: "7sus4b9b13", "value": "7sus4b9b13" },
    { label: '9', isHeader: true },
    { label: "9", "value": "9" },
    { label: "9#11", "value": "9#11" },
    { label: "9#11b13", "value": "9#11b13" },
    { label: "9#5", "value": "9#5" },
    { label: "9#5#11", "value": "9#5#11" },
    { label: "9b13", "value": "9b13" },
    { label: "9b5", "value": "9b5" },
    { label: "9no5", "value": "9no5" },
    { label: "9sus4", "value": "9sus4" },
    { label: '11', isHeader: true },
    { label: "11", "value": "11" },
    { label: "11b9", "value": "11b9" },
    { label: '13', isHeader: true },
    { label: "13", "value": "13" },
    { label: "13#11", "value": "13#11" },
    { label: "13#9", "value": "13#9" },
    { label: "13#9#11", "value": "13#9#11" },
    { label: "13b5", "value": "13b5" },
    { label: "13b9", "value": "13b9" },
    { label: "13b9#11", "value": "13b9#11" },
    { label: "13no5", "value": "13no5" },
    { label: "13sus4", "value": "13sus4" },
];


